var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBarChartVertical = function SvgBarChartVertical(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#894BA2"
    },
    d: "M431.952,112.527h-74.678c-4.661,0-8.44,3.778-8.44,8.44V503.56c0,4.662,3.779,8.44,8.44,8.44h74.678 c4.661,0,8.44-3.778,8.44-8.44V120.967C440.392,116.305,436.613,112.527,431.952,112.527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#763794"
    },
    d: "M431.952,112.527h-33.758V512h33.758c4.661,0,8.44-3.778,8.44-8.44V120.967 C440.392,116.305,436.613,112.527,431.952,112.527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F77935"
    },
    d: "M295.897,196.441h-74.678c-4.661,0-8.44,3.778-8.44,8.44V503.56c0,4.662,3.779,8.44,8.44,8.44h74.678 c4.661,0,8.44-3.778,8.44-8.44V204.881C304.336,200.22,300.557,196.441,295.897,196.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9510D"
    },
    d: "M295.897,196.441h-33.758V512h33.758c4.661,0,8.44-3.778,8.44-8.44V204.881 C304.336,200.22,300.557,196.441,295.897,196.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDB56"
    },
    d: "M159.84,289.753H85.163c-4.661,0-8.44,3.778-8.44,8.44V503.56c0,4.662,3.779,8.44,8.44,8.44h74.678 c4.661,0,8.44-3.778,8.44-8.44V298.192C168.279,293.531,164.501,289.753,159.84,289.753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBA806"
    },
    d: "M159.84,289.753h-33.758V512h33.758c4.661,0,8.44-3.778,8.44-8.44V298.192 C168.279,293.531,164.501,289.753,159.84,289.753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M502.998,512H9.002c-4.661,0-8.44-3.778-8.44-8.44V8.44C0.563,3.778,4.341,0,9.002,0 s8.44,3.778,8.44,8.44v486.681h485.556c4.661,0,8.44,3.778,8.44,8.44S507.659,512,502.998,512z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBarChartVertical, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bar-chart-vertical.2e9ae6dd.svg";
export { ForwardRef as ReactComponent };